module.exports = __webpack_public_path__ + "assets/img/btn-detail-c0b7454e.png";